import "../../../styles/components/viewModal.css";
const ViewLocationModal = ({ data, onClose, title = "Mapped Locations" }) => {
const items = Array.isArray(data?.location_ids)
  ? data.location_ids.map((loc) => loc.name)
  : [];

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          {/* Dynamic title used here */}
          <h3>{title} ({items.length})</h3>
          <span className="close-btn" onClick={onClose}>&times;</span>
        </div>

        <div className="modal-body">
          {items.length > 0 ? (
            <ul style={{ padding: 0, margin: 0 }}>
              {items.map((item, index) => (
                <li key={index} className="location-item">
                  <strong>{index + 1}.</strong> {item}
                </li>
              ))}
            </ul>
          ) : (
            <p className="le-empty-text">No items found.</p>
          )}
        </div>

        <div className="modal-footer">
          <button className="close-modal-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewLocationModal;